import React from "react";

import Banner from "../Banner/Banner";
import MainService from "../MainService/MainServices";
import PopupModal from "../PopupModal/PopupModal";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Popup from API */}
      <PopupModal />

      {/* Hero */}
      <Banner />

      {/* Decorative divider between hero and content */}
      <div className="relative -mt-1">
        <svg
          viewBox="0 0 1440 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-8 md:h-12"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="bannerGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="100%" stopColor="#00053f" />
            </linearGradient>
          </defs>
          <path
            d="M0 0L1440 0V24C1440 24 1080 48 720 48C360 48 0 24 0 24V0Z"
            fill="url(#bannerGrad)"
          />
        </svg>
      </div>

      {/* Main content */}
      <MainService />
    </div>
  );
};

export default Home;
